import React from "react";
import { Tooltip, Typography } from "antd";

interface CopyableTextProps {
  text?: string | null;
  display?: string;
  maxWidth?: number;
}

export const CopyableText: React.FC<CopyableTextProps> = ({
  text,
  display,
  maxWidth = 220,
}) => {
  if (!text) {
    return <span>N/A</span>;
  }

  const visible = display ?? text;

  return (
    <Tooltip title={text}>
      <Typography.Text
        copyable={{ text }}
        style={{ maxWidth, display: "inline-block" }}
        ellipsis
      >
        {visible}
      </Typography.Text>
    </Tooltip>
  );
};
